'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _getClientConfig = require('../../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _PageLoader = require('./PageLoader');

var _PageLoader2 = _interopRequireDefault(_PageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageLoaderSelector = (0, _reselect.createSelector)(function () {
    return {
        quoteText: (0, _lodash.get)((0, _getClientConfig2.default)(), ['quote', 'text']),
        quoteAttribution: (0, _lodash.get)((0, _getClientConfig2.default)(), ['quote', 'attribution'])
    };
});

exports.default = (0, _reactRedux.connect)(pageLoaderSelector)(_PageLoader2.default);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/loaders/PageLoaderContainer.js
// module id = 1906
// module chunks = 0